import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { Form, Button, Card, CardHeader, CardBody, CardFooter, Row, Col, FormGroup, Label } from 'reactstrap'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import timezones from './timezones';
import { getAccountProfile, getAccountProfileOptions, fetchAccountProfile } from '../accountProfileReducer';
import { renderField } from 'core/utils/form';
import { required, minLength } from 'core/utils/validations';
import CardTitle from 'components/ui/CardTitle/CardTitle';
import AccountLogoUpload from '../AccountLogoUpload';

const propTypes = {
  onSubmit: PropTypes.func.isRequired
}

const timeZones = timezones.map(tz => ({key: tz, value: tz}))
const minLength5 = minLength(5)

class AccountProfileForm extends Component {
  constructor() {
    super()
    this.renderStatesSelect = this.renderStatesSelect.bind(this)
  }

  renderStatesSelect({accountOptions, error}) {
    let options, disabled
    const { states } = accountOptions

    if (states) {
      options = states.map(s => {
        return { key: s.postal_code, value: s.postal_code }
      })
      disabled = false
    } else {
      options = []
      disabled = true
    }

    return (
      <Field
        name="address.state.postal_code"
        error={error}
        options={options}
        component={renderField}
        type="select"
        label="State"
        disabled={disabled}
        validate={[required]}
        required={true}
      />
    )
  }

  handleLogoUploadSuccess = () => {
    this.props.fetchAccountProfile();
  }

  render() {
    const { error, handleSubmit, invalid, submitting, initialValues: { logo_url } } = this.props

    return (
      <Card className="pageCard AccountProfileForm">
        <Form onSubmit={handleSubmit}>
          <CardHeader>
            <CardTitle>Account settings</CardTitle>
          </CardHeader>
          <CardBody className="padded">

            <p className="lead">General</p>

            <FormGroup>
              <Label>Logo</Label>
              <AccountLogoUpload
                logo={logo_url}
                onUploadSuccess={this.handleLogoUploadSuccess}
              />
            </FormGroup>

            <Field name="name"
              type="text"
              label="Name"
              error={error}
              component={renderField}
              validate={[required]}
              required={true}
            />
            <Field
              name="time_zone"
              error={error}
              options={timeZones}
              component={renderField}
              type="select"
              label="Time zone"
              validate={[required]}
              required={true}
            />
            <Field
              name="dep_cert_number"
              type="text"
              label="State license number"
              error={error}
              component={renderField}
              validate={[required]}
              required={true}
            />
            <Field
              name="phone"
              type="phone"
              label="Phone number"
              error={error}
              component={renderField}
              validate={[required]}
              required={true}
            />
            <Field
              name="email"
              type="email"
              label="Email"
              error={error}
              component={renderField}
            />
            <Field
              name="url"
              type="text"
              label="URL"
              error={error}
              component={renderField}
            />

            <p className="lead">Address</p>
            <Row>
              <Col xs="12" sm="8">
                <Field
                  name="address.street"
                  type="text"
                  label="Street"
                  error={error}
                  component={renderField}
                  validate={[required]}
                  required={true}
                />
              </Col>
              <Col xs="12" sm="4">
                <Field
                  name="address.street2"
                  type="text"
                  label="Street2"
                  error={error}
                  component={renderField}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12" lg="6">
                <Field
                  name="address.city"
                  type="text"
                  label="City"
                  error={error}
                  component={renderField}
                  validate={[required]}
                  required={true}
                />
              </Col>
              <Col xs="12" sm="6" lg="3">
                {this.renderStatesSelect(this.props)}
              </Col>
              <Col xs="12" sm="6" lg="3">
                <Field
                  name="address.zip_code"
                  type="text"
                  label="Zip code"
                  error={error}
                  component={renderField}
                  validate={[required, minLength5]}
                  required={true}
                />
              </Col>
            </Row>
          </CardBody>

          <CardFooter>
            <Button
              color="primary"
              disabled={invalid || submitting}
            >
              Save
            </Button>
          </CardFooter>
        </Form>
      </Card>
    )
  }
}

AccountProfileForm.propTypes = propTypes

AccountProfileForm = reduxForm({
  form: 'accountProfile'
})(AccountProfileForm)

const mapStateToProps = state => ({
  initialValues: getAccountProfile(state),
  accountOptions: getAccountProfileOptions(state)
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchAccountProfile,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AccountProfileForm)



// WEBPACK FOOTER //
// ./src/features/Account/accountProfile/AccountProfileForm/AccountProfileForm.js